const LanguageTypes = {
    ADD_LANGUAGE: 'ADD_LANGUAGE'
}

export default LanguageTypes;